'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FeatherChevronLeft, FeatherChevronRight } from '@subframe/core';
import { Button } from '../Button';
import { hasNextPage, isTotalKnown, visiblePageNumbers } from './paginationState';
import type { DataTablePaginationProps } from './types';

/**
 * Navegação de páginas server-side. Também serve a listas sem tabela (exportada no barrel).
 * Sem `totalPages`, só "Anterior"/"Próximo" e "Página N": inventar um total a partir de
 * `hasMore` mostraria um "de N" falso.
 */
export function DataTablePagination(t0) {
  const $ = _c(33);
  const {
    pagination,
    onPageChange,
    isLoading: t1,
    nextLabel: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const nextLabel = t2 === undefined ? "Pr\xF3ximo" : t2;
  const {
    page
  } = pagination;
  let t3;
  if ($[0] !== pagination) {
    t3 = isTotalKnown(pagination) ? Math.max(1, pagination.totalPages) : null;
    $[0] = pagination;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const totalPages = t3;
  let t4;
  if ($[2] !== pagination) {
    t4 = hasNextPage(pagination);
    $[2] = pagination;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const canGoNext = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherChevronLeft />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isLoading || page <= 1;
  let t7;
  if ($[5] !== onPageChange || $[6] !== page) {
    t7 = () => onPageChange(page - 1);
    $[5] = onPageChange;
    $[6] = page;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <Button variant="neutral-secondary" size="small" className="min-h-11" icon={t5} disabled={t6} onClick={t7}>Anterior</Button>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FeatherChevronRight />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = isLoading || !canGoNext;
  let t11;
  if ($[12] !== onPageChange || $[13] !== page) {
    t11 = () => onPageChange(page + 1);
    $[12] = onPageChange;
    $[13] = page;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== nextLabel || $[16] !== t10 || $[17] !== t11) {
    t12 = <Button variant="neutral-secondary" size="small" className="min-h-11" iconRight={t9} disabled={t10} onClick={t11}>{nextLabel}</Button>;
    $[15] = nextLabel;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t8) {
    t13 = <div className="flex items-center gap-2">{t8}{t12}</div>;
    $[19] = t12;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== isLoading || $[23] !== onPageChange || $[24] !== page || $[25] !== totalPages) {
    t14 = totalPages !== null && <div className="hidden items-center gap-1 sm:flex">{visiblePageNumbers(page, totalPages).map(pageNumber => <Button key={pageNumber} variant={page === pageNumber ? "brand-secondary" : "neutral-tertiary"} size="small" className="h-8 min-w-[32px] p-0" onClick={() => onPageChange(pageNumber)} disabled={isLoading}>{pageNumber}</Button>)}</div>;
    $[22] = isLoading;
    $[23] = onPageChange;
    $[24] = page;
    $[25] = totalPages;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = totalPages !== null ? `Página ${page} de ${totalPages}` : `Página ${page}`;
  let t16;
  if ($[27] !== t15) {
    t16 = <span className="text-caption text-subtext-color">{t15}</span>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t13 || $[30] !== t14 || $[31] !== t16) {
    t17 = <div className="flex items-center justify-between">{t13}{t14}{t16}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}